<template>
  <div class="editor_wrapper">
    <div class="header">
      <el-row>
        <el-col :span="24">
          <div>
            <!--
            <div class="header-logo">
              <el-image
                @click="$router.push({ path: '/' })"
                class="header-logo-img"
                :src="school_logo"
              ></el-image>
            </div>
-->

            <div class="header-title">
              <span class="header-title-content" @click="back">PYTHON</span>

              <span class="work_title" @click="ChangeWorkTitle">{{ works_title }} <i class="el-icon-edit"></i>
              </span>

              <el-button v-if="plan_id" @click="publicwork" class="publishwork" size="mini" round>提交项目</el-button>
              <el-button v-if="plan_id" @click="savework" class="savework" size="mini" round>保存项目</el-button>

              <el-button v-if="editor_mode == 'look' && workinfo.keepState" @click="updatePyWorkKeepList"
                class="publishwork" size="mini" type="warning" icon="el-icon-star-off" circle></el-button>

              <el-button v-if="editor_mode == 'look' && !workinfo.keepState" @click="updatePyWorkKeepList"
                class="publishwork" size="mini" type="warning" plain icon="el-icon-star-off" circle></el-button>

              <el-button v-if="editor_mode == 'look' && workinfo.zanState" @click="updatePyWorkZanList" class="savework"
                size="mini" type="success" icon="el-icon-thumb" circle></el-button>

              <el-button v-if="editor_mode == 'look' && !workinfo.zanState" @click="updatePyWorkZanList"
                class="savework" size="mini" type="success" icon="el-icon-thumb" plain circle></el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="content">
      <el-row>
        <el-col :span="FilesWidth">
          <div class="left">
            <div class="left_up">
              <span class="left_up_title"> 项目区 </span>

              <span class="left_up_icon" @click="CloseFiles">
                <i class="el-icon-arrow-left"></i>
              </span>

              <el-tooltip class="item" effect="dark" content="添加文件" placement="bottom">
                <span class="left_up_icon" @click="AddPyFile">
                  <i class="el-icon-document"></i>
                </span>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="新建作品" placement="bottom">
                <span class="left_up_icon" @click="CreateWork">
                  <i class="el-icon-reading"></i>
                </span>
              </el-tooltip>
            </div>
            <div class="left_down">
              <el-tree class="filelist" :data="filelist" node-key="id" default-expand-all
                @node-drag-start="handleDragStart" @node-drag-enter="handleDragEnter" @node-drag-leave="handleDragLeave"
                @node-drag-over="handleDragOver" @node-drag-end="handleDragEnd" @node-drop="handleDrop"
                @node-click="FileOnselect" draggable :allow-drop="allowDrop" :allow-drag="allowDrag">
                <span style="width: 100%" slot-scope="{ node, data }">
                  <span style="font-size: 14px; margin-left: 10px">
                    <i :class="data.iconSkin"></i>
                    {{ node.label }}
                  </span>

                  <span v-if="data.selected" class="filecontrol el-icon-delete" @click="DeleteFile(data.id)"></span>

                  <span v-if="data.selected" class="filecontrol el-icon-edit" @click="RenameFile(data.id)"></span>
                </span>
              </el-tree>
            </div>
          </div>
        </el-col>

        <el-col :span="24 - FilesWidth">
          <div class="right">
            <el-row>
              <el-col :span="EditorWidth">
                <div class="editor-wrapper" :style="{ height: Editor_Height }">
                  <div class="editor_up">
                    <span v-if="FilesWidth == 0" class="files_open_icon" @click="OpenFiles">
                      <i class="el-icon-arrow-right"></i>
                    </span>
                    <span v-else class="editor_up_title">代码区</span>

                    <span v-if="!is_photo" class="filename">{{ work_title }}
                    </span>

                    <span v-else class="filename">{{
                        work_title +
                        "(" +
                        is_photo_width +
                        "x" +
                        is_photo_height +
                        ")"
                    }}
                    </span>

                    <el-button v-if="CourseWidth == 0" class="course_btn" size="mini" icon="el-icon-arrow-left" circle
                      @click="OpenCourseInfo"></el-button>

                    <el-popover placement="bottom" width="600" trigger="click">
                      <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="图库" name="first">
                          <el-table :data="gridData" :height="400" highlight-current-row @current-change="CheckImgFile">
                            <el-table-column align="center" width="100" property="title" label="名称"></el-table-column>
                            <el-table-column property="cover" align="center" label="缩略图">
                              <template slot-scope="scope">
                                <el-image style="width: 50px" :src="scope.row.cover"></el-image>
                              </template>
                            </el-table-column>

                            <el-table-column width="50" property="width" label="宽"></el-table-column>

                            <el-table-column width="50" property="height" label="高"></el-table-column>

                            <el-table-column align="center" property="desc" label="简介"></el-table-column>
                          </el-table>

                          <div style="margin-top: 10px; text-align: right">
                            <el-button @click="AddPhoto" size="mini" type="primary" icon="el-icon-check">插入</el-button>
                          </div>
                        </el-tab-pane>
                      </el-tabs>

                      <el-button slot="reference" class="photo_btn" size="mini" icon="el-icon-picture" circle>
                      </el-button>
                    </el-popover>

                    <el-button class="stop_btn" size="mini" icon="el-icon-s-help" circle @click="stopBtn"></el-button>

                    <el-button class="start_btn" size="mini" icon="el-icon-s-flag" circle @click="startBtn"></el-button>
                  </div>

                  <div class="editor_down" :style="{ height: Editor_ContentHeight }">
                    <codemirror :style="{ display: is_photo ? 'none' : 'block' }" class="cmEditor" ref="cmEditor"
                      :value="code" :options="cmOptions" @ready="onCmReady" @focus="onCmFocus"
                      @input="onCmCodeChange" />

                    <div :style="{
                      display: !is_photo ? 'none' : 'block',
                      height: Editor_ContentHeight,
                    }" class="photo_view">
                      <el-image class="photo_view_img" :src="is_photo_url" :style="{ 'margin-top': 20 + 'px' }">
                      </el-image>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="CourseWidth">
                <div class="course-wrapper" :style="{ height: Editor_Height }">
                  <div class="course-up">
                    <span class="course-title">课程引导</span>
                    <span v-if="EditorWidth == 0" @click="ExitFullScreen" class="exitfull_btn"><i
                        class="el-icon-close"></i>退出</span>

                    <span class="full_btn" @click="FullScreen">
                      <i class="el-icon-arrow-right"></i>
                    </span>
                  </div>

                  <div class="course-content" :style="{ height: Editor_Height }" v-html="content" />
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div class="console-wrapper" ref="console">
                  <div class="console_up">
                    <span class="console_btn">控制台</span>

                    <span v-if="Console_Height == '40px'" @click="OpenConsole" class="close_console"
                      :style="{ height: Console_Height }"><i class="el-icon-arrow-up"></i>
                    </span>

                    <span v-else @click="CloseConsole" class="close_console" :style="{ height: Console_Height }"><i
                        class="el-icon-arrow-down"></i>
                    </span>
                    <span v-if="Console_Height !== '40px'" @click="clearBtn" class="clear_btn"><i
                        class="clear_btn_icon el-icon-brush"></i>清空</span>
                  </div>
                  <div id="xterm" class="console_down"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getHomepage } from "@/api/homeset";
import { codemirror } from "vue-codemirror";
//import "codemirror/theme/mdn-like.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/idea.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！

require("codemirror/mode/python/python"); // 这里引入的模式的js，根据设置的mode引入，一定要引入！！

//代码补全提示

import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";

//选中行背景
import "codemirror/addon/selection/active-line"; //光标行背景高亮,styleActiveLine 设置为true

//代码折叠
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/markdown-fold";
import "codemirror/addon/fold/xml-fold";
import "codemirror/addon/fold/indent-fold";

//括号自动闭合
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/edit/closebrackets";

//终端显示
import "xterm/css/xterm.css";
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import { AttachAddon } from "xterm-addon-attach";

import { getPyWorkContent, savePyTchWork } from "@/api/educational";
import {
  updatePyWorkZanList,
  updatePyWorkKeepList,
  updatePyWorkLooks,
} from "@/api/community";

export default {
  name: "python_course",
  data() {
    return {
      school_logo: "",
      title: "",
      code: "",
      cmOptions: {
        tabSize: 4,
        mode: "python",
        //theme: "mdn-like",
        theme: "idea",
        lint: true,
        lineNumbers: true,
        line: true,

        //括号自动闭合
        matchBrackets: true,
        autoCloseBrackets: true,

        styleActiveLine: true, // 显示选中行的样式
        extraKeys: {
          Ctrl: "autocomplete",
          Tab: (cm) => {
            if (cm.somethingSelected()) {      // 存在文本选择
              cm.indentSelection('add');    // 正向缩进文本
            } else {                    // 无文本选择
              cm.replaceSelection(Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");  // 光标处插入 indentUnit 个空格
            }
          }
        },
        autofocus: true,
        // 代码折叠
        gutters: [
          "CodeMirror-lint-markers",
          "CodeMirror-linenumbers",
          "CodeMirror-foldgutter",
        ],
        foldGutter: true, // 启用行槽中的代码折叠
        // more CodeMirror options...
      },

      //websocket
      term: null,
      socket: null,
      started: false,

      //高度适配
      Editor_Height: 0,
      Editor_ContentHeight: 0,
      Console_Height: 0,

      //宽度适配
      FilesWidth: 4,
      EditorWidth: 24,
      CourseWidth: 0,

      work_id: null,

      works_title: "我的作品",
      work_title: "main.py",
      file_id: 0,
      work_num: 1,

      filelist: [
        {
          id: 0,
          type: "py",
          label: "main.py",
          code: "",
          url: "",
          iconSkin: "el-icon-document",
          selected: true,
        },
      ],

      editor_mode: "",

      content: "",
      workinfo: {}, //python作品详情

      is_photo: false, //判断当前文件是否未图片
      is_photo_url: "",
      is_photo_width: 0, //资源宽度
      is_photo_height: 0, //资源高度

      gridData: [
        {
          title: "网格",
          type: "jpeg",
          cover: "https://scratchshop.oss-cn-shanghai.aliyuncs.com/grid.jpeg",
          width: 480,
          height: 360,
          desc: "海龟绘图-网格",
        },
        {
          title: "background",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/background.png",
          width: 960,
          height: 720,
          desc: "飞机大战背景",
        },
        {
          title: "starbg",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/starbg.png",
          width: 960,
          height: 720,
          desc: "星球背景",
        },
        {
          title: "outerspace",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/outerspace.png",
          width: 600,
          height: 800,
          desc: "星际迷航背景",
        },
        {
          title: "ship",
          type: "jpg",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/ship.jpg",
          width: 93,
          height: 89,
          desc: "飞船",
        },
        {
          title: "planet",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/planet.png",
          width: 167,
          height: 47,
          desc: "星球",
        },
        {
          title: "astronaut",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/astronaut.png",
          width: 77,
          height: 100,
          desc: "宇航员",
        },
        {
          title: "alien",
          type: "jpg",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/alien.jpg",
          width: 89,
          height: 96,
          desc: "",
        },
        {
          title: "bg",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/bg.png",
          width: 800,
          height: 600,
          desc: "",
        },
        {
          title: "CrazySmile",
          type: "bmp",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/CrazySmile.bmp",
          width: 100,
          height: 100,
          desc: "",
        },
        {
          title: "smile",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/smile.png",
          width: 274,
          height: 412,
          desc: "",
        },
        {
          title: "dog1",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/dog1.png",
          width: 254,
          height: 216,
          desc: "",
        },
        {
          title: "dog2",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/dog2.png",
          width: 254,
          height: 216,
          desc: "",
        },
        {
          title: "gameover",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/gameover.png",
          width: 800,
          height: 450,
          desc: "",
        },
        {
          title: "gamestart",
          type: "png",
          cover:
            "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/gamestart.png",
          width: 650,
          height: 450,
          desc: "",
        },
        {
          title: "flowers",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/flowers.gif",
          width: 130,
          height: 95,
          desc: "",
        },
        {
          title: "budinggou",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/budinggou.gif",
          width: 450,
          height: 450,
          desc: "布丁狗",
        },

        {
          title: "dahei",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/dahei.png",
          width: 450,
          height: 450,
          desc: "大黑",
        },
        {
          title: "云朵",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E4%BA%91%E6%9C%B5.png",
          width: 2250,
          height: 2250,
          desc: "云朵",
        },
        {
          title: "小绿旗",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E5%B0%8F%E7%BB%BF%E6%97%97.png",
          width: 2250,
          height: 2250,
          desc: "小绿旗",
        },
        {
          title: "心",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E5%BF%83.png",
          width: 2250,
          height: 2250,
          desc: "心",
        },
        {
          title: "树干",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E6%A0%91%E5%B9%B2.png",
          width: 800,
          height: 600,
          desc: "树干",
        },
        {
          title: "点名",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E7%82%B9%E5%90%8D.png",
          width: 500,
          height: 150,
          desc: "点名",
        },
        {
          title: "蝴蝶",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E8%9D%B4%E8%9D%B6.png",
          width: 2250,
          height: 2250,
          desc: "蝴蝶",
        },
        {
          title: "铃铛",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E9%93%83%E9%93%9B.png",
          width: 2250,
          height: 2250,
          desc: "铃铛",
        },
        {
          title: "黑夜",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E9%BB%91%E5%A4%9C.png",
          width: 960,
          height: 720,
          desc: "黑夜",
        },
        {
          title: "黑猫",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/%E9%BB%91%E7%8C%AB.png",
          width: 4260,
          height: 3600,
          desc: "黑猫",
        },
        {
          title: "email",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/email.png",
          width: 800,
          height: 600,
          desc: "email",
        },
        {
          title: "tv",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/tv.png",
          width: 1000,
          height: 600,
          desc: "tv",
        },
        {
          title: "kuang",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/kuang.png",
          width: 200,
          height: 50,
          desc: "kuang",
        },
        {
          title: "qrcode_bg",
          type: "png",
          cover: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/resources/python/qrcode_bg.png",
          width: 400,
          height: 400,
          desc: "qrcode_bg",
        },
        {
          title: "A",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/A.gif",
          width: 100,
          height: 100,
          desc: "A",
        },
        {
          title: "B",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/B.gif",
          width: 100,
          height: 100,
          desc: "B",
        },
        {
          title: "C",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/C.gif",
          width: 100,
          height: 100,
          desc: "C",
        },
        {
          title: "D",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/D.gif",
          width: 100,
          height: 100,
          desc: "D",
        },
        {
          title: "E",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/E.gif",
          width: 100,
          height: 100,
          desc: "E",
        },
        {
          title: "F",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/F.gif",
          width: 100,
          height: 100,
          desc: "F",
        },
        {
          title: "G",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/G.gif",
          width: 100,
          height: 100,
          desc: "G",
        },
        {
          title: "H",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/H.gif",
          width: 100,
          height: 100,
          desc: "H",
        },
        {
          title: "I",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/I.gif",
          width: 100,
          height: 100,
          desc: "I",
        },
        {
          title: "J",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/J.gif",
          width: 100,
          height: 100,
          desc: "J",
        },
        {
          title: "K",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/K.gif",
          width: 100,
          height: 100,
          desc: "K",
        },
        {
          title: "L",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/L.gif",
          width: 100,
          height: 100,
          desc: "L",
        },
        {
          title: "M",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/M.gif",
          width: 100,
          height: 100,
          desc: "M",
        },
        {
          title: "N",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/N.gif",
          width: 100,
          height: 100,
          desc: "N",
        },
        {
          title: "O",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/O.gif",
          width: 100,
          height: 100,
          desc: "O",
        },
        {
          title: "P",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/P.gif",
          width: 100,
          height: 100,
          desc: "P",
        },
        {
          title: "Q",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/Q.gif",
          width: 100,
          height: 100,
          desc: "Q",
        },
        {
          title: "R",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/R.gif",
          width: 100,
          height: 100,
          desc: "R",
        },
        {
          title: "S",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/S.gif",
          width: 100,
          height: 100,
          desc: "S",
        },
        {
          title: "T",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/T.gif",
          width: 100,
          height: 100,
          desc: "T",
        },
        {
          title: "U",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/U.gif",
          width: 100,
          height: 100,
          desc: "U",
        },
        {
          title: "V",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/V.gif",
          width: 100,
          height: 100,
          desc: "V",
        },
        {
          title: "W",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/W.gif",
          width: 100,
          height: 100,
          desc: "W",
        },
        {
          title: "X",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/X.gif",
          width: 100,
          height: 100,
          desc: "X",
        },
        {
          title: "Y",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/Y.gif",
          width: 100,
          height: 100,
          desc: "Y",
        },
        {
          title: "Z",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/Z.gif",
          width: 100,
          height: 100,
          desc: "Z",
        },

        {
          title: "地球",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E5%9C%B0%E7%90%83.gif",
          width: 62,
          height: 62,
          desc: "地球",
        },
        {
          title: "海王星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E6%B5%B7%E7%8E%8B%E6%98%9F.gif",
          width: 72,
          height: 72,
          desc: "海王星",
        },
        {
          title: "火星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E7%81%AB%E6%98%9F.gif",
          width: 45,
          height: 45,
          desc: "火星",
        },

        {
          title: "金星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E9%87%91%E6%98%9F.gif",
          width: 50,
          height: 50,
          desc: "金星",
        },
        {
          title: "木星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E6%9C%A8%E6%98%9F.gif",
          width: 120,
          height: 120,
          desc: "木星",
        },
        {
          title: "水星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E6%B0%B4%E6%98%9F.gif",
          width: 20,
          height: 20,
          desc: "水星",
        },
        {
          title: "天王星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E5%A4%A9%E7%8E%8B%E6%98%9F.gif",
          width: 83,
          height: 83,
          desc: "天王星",
        },
        {
          title: "土星",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/%E5%9C%9F%E6%98%9F.gif",
          width: 153,
          height: 152,
          desc: "土星",
        },

        {
          title: "America",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/America.png",
          width: 1200,
          height: 800,
          desc: "America",
        },

        {
          title: "Britain",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/Britain.png",
          width: 1200,
          height: 800,
          desc: "Britain",
        },

        {
          title: "China",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/China.png",
          width: 1200,
          height: 800,
          desc: "China",
        },

        {
          title: "Russia",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/Russia.png",
          width: 1200,
          height: 800,
          desc: "Russia",
        },
        {
          title: "playground",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/playground.png",
          width: 638,
          height: 581,
          desc: "playground",
        },

        {
          title: "dot",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/dot.png",
          width: 1200,
          height: 800,
          desc: "dot",
        },

        {
          title: "letter",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/letter.png",
          width: 1200,
          height: 800,
          desc: "letter",
        },
        {
          title: "rabbit",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/rabbit.gif",
          width: 29,
          height: 30,
          desc: "rabbit",
        },

        {
          title: "sun",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/sun.png",
          width: 1000,
          height: 800,
          desc: "sun",
        },
        {
          title: "刘亦菲1",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%88%98%E4%BA%A6%E8%8F%B21.png",
          width: 500,
          height: 500,
          desc: "刘亦菲1",
        },

        {
          title: "刘亦菲2",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%88%98%E4%BA%A6%E8%8F%B22.png",
          width: 500,
          height: 500,
          desc: "刘亦菲2",
        },

        {
          title: "半袖",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%8D%8A%E8%A2%96.png",
          width: 800,
          height: 800,
          desc: "半袖",
        },

        {
          title: "卡通眼镜帅哥",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%8D%A1%E9%80%9A%E7%9C%BC%E9%95%9C%E5%B8%85%E5%93%A5.png",
          width: 500,
          height: 500,
          desc: "卡通眼镜帅哥",
        },

        {
          title: "哭泣",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%93%AD%E6%B3%A3.png",
          width: 500,
          height: 500,
          desc: "哭泣",
        },

        {
          title: "大笑",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E5%A4%A7%E7%AC%91.png",
          width: 500,
          height: 500,
          desc: "大笑",
        },

        {
          title: "树",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E6%A0%91.png",
          width: 1080,
          height: 1920,
          desc: "树",
        },

        {
          title: "测颜值",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E6%B5%8B%E9%A2%9C%E5%80%BC.png",
          width: 700,
          height: 700,
          desc: "测颜值",
        },

        {
          title: "甄嬛哭",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E7%94%84%E5%AC%9B%E5%93%AD.png",
          width: 500,
          height: 500,
          desc: "甄嬛哭",
        },

        {
          title: "缩略图",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E7%BC%A9%E7%95%A5%E5%9B%BE.png",
          width: 260,
          height: 260,
          desc: "缩略图",
        },

        {
          title: "花",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E8%8A%B1.png",
          width: 690,
          height: 920,
          desc: "花",
        },

        {
          title: "螃蟹",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E8%9E%83%E8%9F%B9.png",
          width: 800,
          height: 1067,
          desc: "螃蟹",
        },

        {
          title: "豹子",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1104/%E8%B1%B9%E5%AD%90.png",
          width: 500,
          height: 675,
          desc: "豹子",
        },
        {
          title: "按钮",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1207/%E6%8C%89%E9%92%AE.png",
          width: 88,
          height: 88,
          desc: "按钮",
        },

        {
          title: "十秒挑战",
          type: "png",
          cover: "https://wuge.steam.fun/resources/python/1207/%E5%8D%81%E7%A7%92%E6%8C%91%E6%88%98.png",
          width: 300,
          height: 400,
          desc: "十秒挑战",
        },

        {
          title: "星图",
          type: "gif",
          cover: "https://wuge.steam.fun/resources/python/1207/%E6%98%9F%E5%9B%BE.gif",
          width: 320,
          height: 360,
          desc: "星图",
        }
      ],

      activeName: "first",
      has_select_img: null,

      plan_id: null,
    };
  },

  watch: {
    started() {
      console.log("程序启动状态");
      console.log(this.started);

      if (this.started) {
        this.started = false;
        this.StartPy();
      }
    },

    content() {
      console.log("富文本源码");
      console.log(this.content);
    },
  },

  components: {
    codemirror,
  },

  computed: {
    codemirror() {
      return this.$refs.cmEditor.codemirror;
    },
  },

  mounted() {
    console.log("the current CodeMirror instance object:", this.codemirror);

    getHomepage().then((res) => {
      console.log("校区LOGO");
      console.log(res);
      if (res.homepageData) {
        console.log("有校区LOGO");

        this.school_logo = res.homepageData.homepage.logo_img_url;

        console.log(this.school_logo);
      }
    });
    this.initSocket();

    this.$nextTick(() => {
      this.initDOM();

      if (this.$route.query.type == "1") {
        console.log("PY课堂完整版程序");
        //console.log(localStorage.getItem("exampal_work_url"));
        console.log("this.curriculumMaterial");
        console.log(this.$route.params.curriculumMaterial);

        this.filelist = JSON.parse(
          this.$route.params.curriculumMaterial.exampal_work_url
        );

        for (let k = 0; k < this.filelist.length; k++) {
          this.filelist[k].id = k;
          if (this.filelist[k].selected) {
            this.code = this.filelist[k].code;
            this.work_title = this.filelist[k].label;
          }
        }

        this.works_title = this.$route.query.title;

        this.content = this.$route.params.curriculumMaterial.home_template_url;
      } else if (this.$route.query.type == "2") {
        console.log("lessionInfo");
        console.log(this.$route.params);
        console.log(this.$route.params.lessionInfo);

        console.log("stuTchPlanInfo");
        console.log(this.$route.params.stuTchPlanInfo);

        if (this.$route.query.operate == "1") {
          console.log("PY授课空模板程序");

          if (this.$route.params.lessionInfo.teach_template_url) {
            this.filelist = JSON.parse(
              this.$route.params.lessionInfo.teach_template_url
            );
          }

          this.works_title = this.$route.query.title;
          this.content = this.$route.params.lessionInfo.home_template_url;
        } else if (this.$route.query.operate == "2") {
          console.log("PY课堂作品");
          this.filelist = JSON.parse(
            this.$route.params.stuTchPlanInfo.classWorkInfo.work_url
          );
          this.works_title =
            this.$route.params.stuTchPlanInfo.classWorkInfo.title;
          this.content = this.$route.params.lessionInfo.home_template_url;

          this.CourseWidth = 0;
          this.EditorWidth = 24;
        } else if (this.$route.query.operate == "3") {
          console.log("PY课后作业");
          if (this.$route.params.lessionInfo.teach_template_url) {
            this.filelist = JSON.parse(
              this.$route.params.lessionInfo.teach_template_url
            );
          }

          this.works_title = this.$route.query.title;
          this.content = this.$route.params.lessionInfo.home_template_url;
        } else if (this.$route.query.operate == "4") {
          this.filelist = JSON.parse(
            this.$route.params.stuTchPlanInfo.homeWorkInfo.work_url
          );
          this.works_title =
            this.$route.params.stuTchPlanInfo.homeWorkInfo.title;
          this.content = this.$route.params.lessionInfo.home_template_url;

          this.CourseWidth = 0;
          this.EditorWidth = 24;
        } else if (this.$route.query.operate == "5") {
          console.log("备课资料");
          this.filelist = JSON.parse(
            this.$route.params.curriculumMaterial.teach_template_url
          );
          this.works_title = this.$route.query.title;
          this.content =
            this.$route.params.curriculumMaterial.home_template_url;
        }

        for (let k = 0; k < this.filelist.length; k++) {
          this.filelist[k].id = k;
          if (this.filelist[k].selected) {
            this.code = this.filelist[k].code;
            this.work_title = this.filelist[k].label;
          }
        }
      } else if (this.$route.query.type == "3") {
        console.log("PY课堂作品111");

        console.log(this.$route.params.work_url);

        this.filelist = JSON.parse(this.$route.params.work_url);
        this.works_title = this.$route.query.title;
        this.content = "";

        this.CourseWidth = 0;
        this.EditorWidth = 24;

        for (let k = 0; k < this.filelist.length; k++) {
          this.filelist[k].id = k;
          if (this.filelist[k].selected) {
            this.code = this.filelist[k].code;
            this.work_title = this.filelist[k].label;
          }
        }
      }

      if (this.$route.query.plan_id) {
        this.plan_id = this.$route.query.plan_id;
      }
    });
  },

  beforeDestroy() {
    this.socket.close();
    this.term.dispose();
  },

  methods: {
    back() {
      this.$confirm("即将离开，记得保存作品哦！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.go(-1);
      });
    },

    initDOM() {
      this.Editor_Height =
        document.documentElement.clientHeight * 0.75 - 80 + "px";
      this.Console_Height = document.documentElement.clientHeight * 0.25 + "px";
      this.Editor_ContentHeight =
        document.documentElement.clientHeight * 0.75 - 130 + "px";
    },

    StartPy() {
      console.log("运行PY文件");
      document.getElementById("xterm").innerText = "";
      this.socket = new WebSocket("ws://localhost:1884");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
      this.socketOnClose();
      this.socketOnOpen();
      this.socketOnError();
    },

    onCmReady(cm) {
      console.log("the editor is readied!", cm);
      // 这里的 cm 对象就是 codemirror 对象，等于 this.$refs.myCm.codemirror
      cm.on("inputRead", (cm, obj) => {
        if (obj.text && obj.text.length > 0) {
          let c = obj.text[0].charAt(obj.text[0].length - 1);
          if ((c >= "a" && c <= "z") || (c >= "A" && c <= "Z")) {
            cm.showHint({ completeSingle: false });
          }
        }
      });
    },
    onCmFocus(cm) {
      console.log("the editor is focused!", cm);
    },
    onCmCodeChange(newCode) {
      console.log("this is new code", newCode);
      console.log(this.file_id);
      this.code = newCode;

      for (let k = 0; k < this.filelist.length; k++) {
        if (this.filelist[k].id == this.file_id) {
          this.filelist[k].code = newCode;
        }
      }
    },

    startBtn() {
      console.log("开始运行");
      console.log(this.code);
      if (this.socket) {
        this.socket.removeEventListener("message", this.onSocketRx);
        this.socket.close();
        this.term.clear();
      }
      if (this.code.length > 0) {
        console.log("fileSocket.create");
        this.fileSocket = new WebSocket("ws://localhost:1885");
        this.fileSocketOnClose();
        this.fileSocketOnOpen();
        this.fileSocketOnError();
      }
    },

    stopBtn() {
      document.getElementById("xterm").innerText = "";
      this.socket.removeEventListener("message", this.onSocketRx);
      this.socket.close();
      this.socket = new WebSocket("ws://localhost:1883");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
    },

    //终端显示
    initTerm() {
      const term = new Terminal({
        fontSize: 14,
        cursorBlink: true,
        rows: 11, //行数
        theme: {
          foreground: "white", //字体
          background: "#3f3f3f", //背景色
          cursor: "help", //设置光标
        },
      });
      const attachAddon = new AttachAddon(this.socket);
      const fitAddon = new FitAddon();
      term.loadAddon(attachAddon);
      term.loadAddon(fitAddon);

      term.open(document.getElementById("xterm"));

      fitAddon.fit();
      term.focus();
      this.term = term;
    },
    initSocket() {
      this.socket = new WebSocket("ws://localhost:1883");
      this.socket.onmessage = this.onSocketRx;
      this.initTerm();
      this.socketOnClose();
      this.socketOnOpen();
      this.socketOnError();
    },

    socketOnOpen() {
      this.socket.onopen = () => {
        // 链接成功后
        //this.initTerm();
      };
    },

    socketOnClose() {
      this.socket.onclose = () => {
        // console.log('close socket')
      };
    },
    socketOnError() {
      this.socket.onerror = () => {
        // console.log('socket 链接失败')
      };
    },

    //文件websocket
    fileSocketOnOpen() {
      this.fileSocket.onopen = () => {
        // 链接成功后
        console.log("文件websocket连接成功");
        this.fileSocket.send(JSON.stringify(this.filelist));
        this.fileSocket = null;
      };
    },
    fileSocketOnClose() {
      this.fileSocket.onclose = () => {
        this.started = true;
        console.log("fileSocket.onclose");
      };
    },
    fileSocketOnError() {
      this.fileSocket.onerror = () => {
        // console.log('socket 链接失败')
      };
    },

    onSocketRx(event) {
      console.log("onSocketRx");
      console.log(event.data);
    },

    clearBtn() {
      this.term.clear();
    },

    CloseConsole() {
      console.log("关闭调试框");

      this.Editor_Height = document.documentElement.clientHeight - 100 + "px";
      this.Console_Height = "40px";
      this.Editor_ContentHeight =
        document.documentElement.clientHeight - 100 - 50 + "px";
    },

    OpenConsole() {
      console.log("打开调试框");
      this.Editor_Height =
        document.documentElement.clientHeight * 0.75 - 80 + "px";
      this.Console_Height = document.documentElement.clientHeight * 0.25 + "px";
      this.Editor_ContentHeight =
        document.documentElement.clientHeight * 0.75 - 130 + "px";
    },

    OpenFiles() {
      console.log("打开文件管理");
      this.FilesWidth = 4;
    },

    CloseFiles() {
      console.log("关闭文件管理");
      this.FilesWidth = 0;
    },

    FullScreen() {
      console.log("进入全屏");
      this.EditorWidth = 24;
      this.CourseWidth = 0;
    },

    OpenCourseInfo() {
      console.log("课堂指引");
      this.EditorWidth = 16;
      this.CourseWidth = 8;
    },

    ExitFullScreen() {
      console.log("退出全屏");
      this.EditorWidth = 16;
      this.CourseWidth = 8;
      this.OpenFiles();
      this.OpenConsole();
    },

    //远程加载py文件代码

    getcode(e) {
      var that = this;
      axios({
        method: "get",
        url: e,
        responseType: "blob",
      }).then(function (response) {
        console.log(response.data);
        let blob = response.data;
        let reader = new FileReader();
        reader.readAsBinaryString(blob);
        reader.onload = (e) => {
          console.log(e.target.result);
          that.code = e.target.result;
        };
      });
    },

    //文档目录
    FileOnselect(val1, val2, val3) {
      console.log("节点被点击");
      console.log(val1);
      console.log(val2);
      console.log(val3);

      console.log(this.file_id);

      this.file_id = val1.id;
      this.work_title = val1.label;

      if (val1.type == "py") {
        this.is_photo = false;
        this.code = val1.code;
        //this.getcode(val1.url);
      } else {
        this.is_photo = true;
        this.is_photo_url = val1.url;
        this.is_photo_width = val1.width;
        this.is_photo_height = val1.height;
      }

      //更改文件选中状态
      for (let k = 0; k < this.filelist.length; k++) {
        if (val1.id == this.filelist[k].id) {
          this.filelist[k].selected = true;
        } else {
          this.filelist[k].selected = false;
        }
      }
    },

    //新建作品
    CreateWork() {
      this.$prompt("请输入作品名称,记得保存当前作品哦！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            this.works_title = value;
            this.file_id = 0;

            (this.filelist = [
              {
                id: 0,
                type: "py",
                label: "main.py",
                code: "",
                url: "",
                iconSkin: "el-icon-document",
                selected: true,
              },
            ]),
              (this.code = "");
            this.work_id = null;

            this.$message({
              type: "success",
              message: "新建作品成功",
            });
          } else {
            this.$message({
              type: "info",
              message: "取消新建",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消新建",
          });
        });
    },

    ChangeWorkTitle() {
      this.$prompt("请输入作品名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            this.works_title = value;
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message({
              type: "info",
              message: "取消修改",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
        });
    },

    AddPyFile() {
      this.$prompt("请输入文件名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            const pyfile = {
              id: this.filelist.length,
              type: "py",
              label: value + ".py",
              code: "",
              url: "",
              iconSkin: "el-icon-document",
              selected: false,
            };

            this.filelist.push(pyfile);
            this.code = "";

            this.$message({
              type: "success",
              message: "新增文件: " + value + ".py",
            });

            this.file_id = this.filelist.length - 1;
            //更改文件选中状态
            for (let k = 0; k < this.filelist.length; k++) {
              if (this.filelist[k].id == this.file_id) {
                this.filelist[k].selected = true;
                this.work_title = this.filelist[k].label;

                if (this.filelist[k].type == "py") {
                  this.is_photo = false;
                  this.code = this.filelist[k].code;
                  //this.getcode(val1.url);
                } else {
                  this.is_photo = true;
                  this.is_photo_url = this.filelist[k].url;
                  this.is_photo_width = this.filelist[k].width;
                  this.is_photo_height = this.filelist[k].height;
                }
              } else {
                this.filelist[k].selected = false;
              }
            }
          } else {
            this.$message({
              type: "info",
              message: "取消添加",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消添加",
          });
        });
    },

    //获得自由创作作品详情

    getPyWorkContent() {
      getPyWorkContent({
        work_id: this.work_id,
      }).then((res) => {
        console.log("python作品详情");
        console.log(res);
        this.works_title = res.pyWork.title;
        console.log("项目信息");
        console.log(JSON.parse(res.pyWork.work_url));
        this.filelist = JSON.parse(res.pyWork.work_url);
        this.workinfo = res.pyWork;

        for (let k = 0; k < this.filelist.length; k++) {
          if (this.filelist[k].selected) {
            this.file_id = this.filelist[k].id;
            this.work_title = this.filelist[k].label;
            this.code = this.filelist[k].code;
          }
        }
      });
    },

    //更新作品浏览次数
    updatePyWorkLooks() {
      updatePyWorkLooks({
        work_id: this.work_id,
      }).then((res) => {
        console.log("更新PYTHON浏览次数");
        console.log(res);
      });
    },

    //添加PY文件
    /* AddPyFile() {
      console.log("添加项目文件");

      this.work_id = this.work_id+1;

      const pyfile = {
        id: this.work_id,
        type: "py",
        label: "new1.py",
        code: "",
        url: "",
        iconSkin: "el-icon-document",
        selected: true,
      };
      
      this.filelist.push(pyfile);
      this.code = "";
    },

    */

    //发布作品

    publicwork() {
      console.log("保存项目");
      console.log(this.works_title);
      console.log(JSON.stringify(this.filelist));

      for (let k = 0; k < this.filelist.length; k++) {
        console.log("项目文件列表");
        console.log(this.filelist[k]);
      }

      console.log("savePyTchWork参数");
      console.log(this.$store.state.user.userInfo.code);
      console.log(JSON.stringify(this.filelist));

      console.log(this.works_title);

      console.log(
        this.$route.query.operate == "1" || this.$route.query.operate == "2"
          ? "1"
          : "2"
      );

      if (this.plan_id) {
        console.log("更新项目");
        savePyTchWork({
          stu_user_id: this.$store.state.user.userInfo.id,
          stu_tch_plan_id: this.plan_id,
          work_url: JSON.stringify(this.filelist), //作品信息
          covers:
            "https://wugecdn.steam.fun/resources/static/work_python.png",
          title: this.works_title,
          is_local: false,
          work_type:
            this.$route.query.operate == "1" || this.$route.query.operate == "2"
              ? "1"
              : "2",
        }).then((res) => {
          console.log("保存PYTHON项目");
          console.log(res);
          if (res.is_update || res.is_save) {
            this.$message.success("提交成功");
          } else if (res.is_create) {
            this.$message.success("提交成功");
          }
        });
      }
    },

    //作品保存
    savework() {
      console.log("保存项目");
      console.log(this.works_title);
      console.log(JSON.stringify(this.filelist));

      for (let k = 0; k < this.filelist.length; k++) {
        console.log("项目文件列表");
        console.log(this.filelist[k]);
      }

      console.log("savePyTchWork参数");
      console.log(this.$store.state.user.userInfo.code);
      console.log(JSON.stringify(this.filelist));

      console.log(this.works_title);

      console.log(
        this.$route.query.operate == "1" || this.$route.query.operate == "2"
          ? "1"
          : "2"
      );

      if (this.plan_id) {
        console.log("更新项目");
        savePyTchWork({
          stu_user_id: this.$store.state.user.userInfo.id,
          stu_tch_plan_id: this.plan_id,
          work_url: JSON.stringify(this.filelist), //作品信息
          covers:
            "https://wugecdn.steam.fun/resources/static/work_python.png",
          title: this.works_title,
          is_local: false,
          work_type:
            this.$route.query.operate == "1" || this.$route.query.operate == "2"
              ? "1"
              : "2",
        }).then((res) => {
          console.log("保存PYTHON项目");
          console.log(res);

          if (res.is_create) {
            this.$message.success("保存成功");
          } else if (res.is_update || res.is_save) {
            this.$message.success("保存成功");
          }
        });
      }
    },

    //删除文件
    DeleteFile(id) {
      console.log("删除文件");
      console.log(id);

      if (this.filelist.length == 1) {
        this.$message.warning("至少保留一个文件");
        return;
      }

      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          for (let k = 0; k < this.filelist.length; k++) {
            if (this.filelist[k].id == id) {
              this.filelist.splice(k, 1);
            }
          }

          this.file_id = 0;
          //更改文件选中状态
          for (let k = 0; k < this.filelist.length; k++) {
            this.filelist[k].id = k;
            if (this.filelist[k].id == this.file_id) {
              this.filelist[k].selected = true;
              this.work_title = this.filelist[k].label;

              if (this.filelist[k].type == "py") {
                this.is_photo = false;
                this.code = this.filelist[k].code;
                //this.getcode(val1.url);
              } else {
                this.is_photo = true;
                this.is_photo_url = this.filelist[k].url;
                this.is_photo_width = this.filelist[k].width;
                this.is_photo_height = this.filelist[k].height;
              }
            } else {
              this.filelist[k].selected = false;
            }
          }

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //文件重命名
    RenameFile(id) {
      console.log("文件重命名");
      console.log(id);

      this.$prompt("请输入文件名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            for (let k = 0; k < this.filelist.length; k++) {
              if (this.filelist[k].id == id) {
                this.filelist[k].label = value;
              }
            }

            this.work_title = value;

            console.log(this.filelist);

            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message({
              type: "info",
              message: "取消修改",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消修改",
          });
        });
    },

    //作品点赞

    updatePyWorkZanList() {
      updatePyWorkZanList({
        work_id: this.work_id,
        operate_state: this.workinfo.zanState ? "2" : "1",
      }).then((res) => {
        console.log("python作品点赞");
        console.log(res);
        if (res.is_update) {
          this.$message.success("点赞成功");
        } else if (res.is_delete) {
          this.$message.success("取消点赞");
        }
        this.getPyWorkContent();
      });
    },

    //作品收藏
    updatePyWorkKeepList() {
      updatePyWorkKeepList({
        work_id: this.work_id,
        operate_state: this.workinfo.keepState ? "2" : "1",
      }).then((res) => {
        console.log("python作品收藏");
        console.log(res);
        if (res.is_update) {
          this.$message.success("收藏成功");
        } else if (res.is_delete) {
          this.$message.success("取消收藏");
        }
        this.getPyWorkContent();
      });
    },

    //添加图片资源

    AddPhoto() {
      console.log("添加图片");
      if (this.has_select_img == null) {
        this.$message.warning("请选择图片");
        return;
      } else {
        const photofile = {
          id: this.filelist.length,
          type: this.has_select_img.type,
          label: this.has_select_img.title + "." + this.has_select_img.type,
          width: this.has_select_img.width,
          height: this.has_select_img.height,
          code: "",
          url: this.has_select_img.cover,
          iconSkin: "el-icon-picture",
          selected: false,
        };

        this.filelist.push(photofile);

        this.$message.success("插入成功");
      }
    },

    //选择图库
    CheckImgFile(val) {
      console.log(val);
      this.has_select_img = val;
    },

    handleDragStart(node, ev) {
      console.log("drag start", node);
      console.log(ev);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      console.log("tree drag enter: ", dropNode.label);
      console.log(ev);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      console.log("tree drag leave: ", dropNode.label);
      console.log(ev);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      console.log("tree drag over: ", dropNode.label);
      console.log(ev);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      console.log("tree drag end: ", dropNode && dropNode.label, dropType);
      console.log(ev);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType);
      console.log(ev);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === "二级 3-1") {
        return type !== "inner";
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.editor_wrapper {
  background: #e2f4ff;
  height: 100vh;
  overflow: hidden;

  .header {
    width: 100%;
    height: 60px;
    background: #3f3f3f;

    .header-logo {
      width: 120px;
      height: 40px;
      margin-left: 20px;
      margin-top: 10px;

      .header-logo-img {
        width: 100%;
      }
    }

    .header-title {
      line-height: 55px;
      background: #3877ac;

      .header-title-content {
        margin-left: 10px;
        color: white;
        font-size: 18px;
        cursor: pointer;
      }

      .work_files {
        margin-left: 40px;
        color: white;
        font-size: 16px;
        cursor: pointer;
      }

      .work_title {
        margin-left: 40px;
        color: black;
        font-size: 14px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 40px;
        padding-right: 40px;
        background: white;
        border-radius: 10px;
        cursor: pointer;
      }

      .savework {
        float: right;
        margin-right: 20px;
        margin-top: 15px;
      }

      .publishwork {
        float: right;
        margin-right: 10px;
        margin-top: 15px;
      }
    }

    .file {
      position: absolute;
      left: 170px;
      top: 20px;
      font-size: 16px;
      font-weight: 700;
      color: white;
    }

    .title_input {
      position: absolute;
      width: 150px;
      left: 250px;
      top: 16px;
    }
  }

  .content {
    width: 100%;
    height: calc(100vh - 60px);
    background: #3f3f3f;

    .left {
      // margin-left: 10px;
      //margin-top: 10px;
      // margin-bottom: 10px;
      height: calc(100vh - 80px);

      .left_up {
        width: 100%;
        height: 50px;
        background: #5a6165;
        color: #9d9d9d;

        .left_up_title {
          line-height: 50px;
          margin-left: 10px;
          font-weight: bold;
        }

        .left_up_icon {
          float: right;
          margin-top: 10px;
          margin-right: 10px;
          padding: 5px;
          color: white;
          cursor: pointer;
        }
      }

      .left_down {
        //  margin-top: 10px;
        width: 100%;
        height: calc(100vh - 110px);
        background: #5a6165;

        .filelist {
          background: #5a6165;
          color: white;

          .filecontrol {
            float: right;
            margin-right: 10px;
            margin-top: 4px;
            font-size: 14px;
          }
        }
      }
    }

    .right {
      height: calc(100vh - 80px);

      .editor-wrapper {
        .editor_up {
          height: 50px;
          background: #e8f0ff;
          line-height: 50px;

          .files_open_icon {
            margin-top: 10px;
            margin-left: 10px;
            padding: 5px;
            background: #5a6165;
            cursor: pointer;
            color: white;
          }

          .editor_up_title {
            color: #9d9d9d;
            margin-left: 10px;
            font-weight: bold;
          }

          .filename {
            color: #9d9d9d;
            margin-left: 10px;
            font-weight: bold;
          }

          .start_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: green;
            background: white;
            border: 0px;
          }

          .stop_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: red;
            background: white;
            border: 0px;
          }

          .photo_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: black;
            background: white;
            border: 0px;
          }

          .course_btn {
            float: right;
            margin-right: 10px;
            margin-top: 10px;
            color: white;
            background: #5a6165;
            border: 0px;
          }
        }

        .editor_down {
          background: #ffffff;
          overflow-y: scroll !important;

          .photo_view {
            overflow-y: scroll;

            .photo_view_img {
              width: 50%;
              margin-left: 25%;
            }
          }
        }
      }

      .course-wrapper {
        background: white;
        border-left: 1px solid gainsboro;

        .course-up {
          height: 50px;
          background: #e8f0ff;
          line-height: 50px;

          .course-title {
            color: #757575;
            margin-left: 10px;
            font-weight: bold;
          }

          .full_btn {
            float: right;
            margin-right: 10px;
            font-size: 14px;
            color: #6e6e6e;
            font-weight: bold;
            cursor: pointer;
          }

          .exitfull_btn {
            float: right;
            margin-right: 10px;
            font-size: 14px;
            color: #6e6e6e;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .course-content {
          padding: 5px;
          overflow-y: scroll;
        }

        .content {
          background: red;
        }
      }

      .console-wrapper {
        .console_up {
          height: 40px;
          background: #e8f0ff;
          line-height: 40px;

          .console_btn {
            margin-left: 10px;
            color: #9d9d9d;
            font-weight: bold;
          }

          .clear_btn {
            float: right;
            margin-right: 10px;
            cursor: pointer;
            font-weight: bold;
          }

          .close_console {
            float: right;
            margin-right: 10px;
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style> 
 

 <style>
.editor_wrapper .el-input__inner {
  background: #eaeaea;
}

.CodeMirror {
  height: auto !important;
}

.editor_wrapper .el-tree-node__content {
  width: 100%;
}

.editor_wrapper .el-dialog__header {
  display: none;
}

.editor_wrapper .el-dialog__body {
  padding: 0;
}

.editor_wrapper .el-tree-node:focus>.el-tree-node__content {
  background-color: #66b1ff87 !important;
}

.editor_wrapper .el-tree-node__content:hover {
  background-color: #66b1ff87;
}

.editor_wrapper .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #66b1ff87;
}
</style>